import types from './types';

const INITIAL_STATE = {
  isValidating: false,
  
  result: [],
};

const authPMTProvReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.VALIDATE_DUPLICATE_AUTH_REQUEST:
      return {
        ...state,
        result: [],
        isValidating: true,
      };
  
    case types.VALIDATE_DUPLICATE_AUTH_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isValidating: false,
      };
  
    case types.VALIDATE_DUPLICATE_AUTH_FAILURE:
      return {
        ...state,
        result: [],
        isValidating: false,
      };

  default:
    return state;
  }
};

export default authPMTProvReducer;
